module.exports = __webpack_public_path__ + "static/media/bath-srpn.304304dc.md";